var _excluded = ["mark", "encoding", "params", "projection"],
  _excluded2 = ["color", "size"],
  _excluded3 = ["tooltip"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isNumber, isObject } from 'vega-util';
import { getMarkPropOrConfig } from '../compile/common';
import { extractTransformsFromEncoding, normalizeEncoding } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
import { accessWithDatumToUnescapedPath, isEmpty, omit, removePathFromField } from '../util';
import { CompositeMarkNormalizer } from './base';
import { compositeMarkContinuousAxis, compositeMarkOrient, filterTooltipWithAggregatedField, getCompositeMarkTooltip, getTitle, makeCompositeAggregatePartFactory, partLayerMixins } from './common';
export var BOXPLOT = 'boxplot';
export var BOXPLOT_PARTS = ['box', 'median', 'outliers', 'rule', 'ticks'];
export var boxPlotNormalizer = new CompositeMarkNormalizer(BOXPLOT, normalizeBoxPlot);
export function getBoxPlotType(extent) {
  if (isNumber(extent)) {
    return 'tukey';
  }
  // Ham: If we ever want to, we could add another extent syntax `{kIQR: number}` for the original [Q1-k*IQR, Q3+k*IQR] whisker and call this boxPlotType = `kIQR`. However, I'm not exposing this for now.
  return extent;
}
export function normalizeBoxPlot(spec, _ref) {
  var _markDef$extent;
  var config = _ref.config;
  // Need to initEncoding first so we can infer type
  spec = _objectSpread(_objectSpread({}, spec), {}, {
    encoding: normalizeEncoding(spec.encoding, config)
  });
  var _spec = spec,
    mark = _spec.mark,
    _encoding = _spec.encoding,
    params = _spec.params,
    _p = _spec.projection,
    outerSpec = _objectWithoutProperties(_spec, _excluded);
  var markDef = isMarkDef(mark) ? mark : {
    type: mark
  };
  // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support
  if (params) {
    log.warn(log.message.selectionNotSupported('boxplot'));
  }
  var extent = (_markDef$extent = markDef.extent) !== null && _markDef$extent !== void 0 ? _markDef$extent : config.boxplot.extent;
  var sizeValue = getMarkPropOrConfig('size', markDef,
  // TODO: https://github.com/vega/vega-lite/issues/6245
  config);
  var invalid = markDef.invalid;
  var boxPlotType = getBoxPlotType(extent);
  var _boxParams = boxParams(spec, extent, config),
    bins = _boxParams.bins,
    timeUnits = _boxParams.timeUnits,
    transform = _boxParams.transform,
    continuousAxisChannelDef = _boxParams.continuousAxisChannelDef,
    continuousAxis = _boxParams.continuousAxis,
    groupby = _boxParams.groupby,
    aggregate = _boxParams.aggregate,
    encodingWithoutContinuousAxis = _boxParams.encodingWithoutContinuousAxis,
    ticksOrient = _boxParams.ticksOrient,
    boxOrient = _boxParams.boxOrient,
    customTooltipWithoutAggregatedField = _boxParams.customTooltipWithoutAggregatedField;
  var aliasedFieldName = removePathFromField(continuousAxisChannelDef.field);
  var color = encodingWithoutContinuousAxis.color,
    size = encodingWithoutContinuousAxis.size,
    encodingWithoutSizeColorAndContinuousAxis = _objectWithoutProperties(encodingWithoutContinuousAxis, _excluded2);
  var makeBoxPlotPart = function makeBoxPlotPart(sharedEncoding) {
    return makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, config.boxplot);
  };
  var makeBoxPlotExtent = makeBoxPlotPart(encodingWithoutSizeColorAndContinuousAxis);
  var makeBoxPlotBox = makeBoxPlotPart(encodingWithoutContinuousAxis);
  var defaultBoxColor = (isObject(config.boxplot.box) ? config.boxplot.box.color : config.mark.color) || '#4c78a8';
  var makeBoxPlotMidTick = makeBoxPlotPart(_objectSpread(_objectSpread(_objectSpread({}, encodingWithoutSizeColorAndContinuousAxis), size ? {
    size: size
  } : {}), {}, {
    color: {
      condition: _objectSpread({
        test: "".concat(accessWithDatumToUnescapedPath("lower_box_".concat(continuousAxisChannelDef.field)), " >= ").concat(accessWithDatumToUnescapedPath("upper_box_".concat(continuousAxisChannelDef.field)))
      }, color || {
        value: defaultBoxColor
      })
    }
  }));
  var fiveSummaryTooltipEncoding = getCompositeMarkTooltip([{
    fieldPrefix: boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_',
    titlePrefix: 'Max'
  }, {
    fieldPrefix: 'upper_box_',
    titlePrefix: 'Q3'
  }, {
    fieldPrefix: 'mid_box_',
    titlePrefix: 'Median'
  }, {
    fieldPrefix: 'lower_box_',
    titlePrefix: 'Q1'
  }, {
    fieldPrefix: boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_',
    titlePrefix: 'Min'
  }], continuousAxisChannelDef, encodingWithoutContinuousAxis);
  // ## Whisker Layers
  var endTick = {
    type: 'tick',
    color: 'black',
    opacity: 1,
    orient: ticksOrient,
    invalid: invalid,
    aria: false
  };
  var whiskerTooltipEncoding = boxPlotType === 'min-max' ? fiveSummaryTooltipEncoding // for min-max, show five-summary tooltip for whisker
  :
  // for tukey / k-IQR, just show upper/lower-whisker
  getCompositeMarkTooltip([{
    fieldPrefix: 'upper_whisker_',
    titlePrefix: 'Upper Whisker'
  }, {
    fieldPrefix: 'lower_whisker_',
    titlePrefix: 'Lower Whisker'
  }], continuousAxisChannelDef, encodingWithoutContinuousAxis);
  var whiskerLayers = [].concat(_toConsumableArray(makeBoxPlotExtent({
    partName: 'rule',
    mark: {
      type: 'rule',
      invalid: invalid,
      aria: false
    },
    positionPrefix: 'lower_whisker',
    endPositionPrefix: 'lower_box',
    extraEncoding: whiskerTooltipEncoding
  })), _toConsumableArray(makeBoxPlotExtent({
    partName: 'rule',
    mark: {
      type: 'rule',
      invalid: invalid,
      aria: false
    },
    positionPrefix: 'upper_box',
    endPositionPrefix: 'upper_whisker',
    extraEncoding: whiskerTooltipEncoding
  })), _toConsumableArray(makeBoxPlotExtent({
    partName: 'ticks',
    mark: endTick,
    positionPrefix: 'lower_whisker',
    extraEncoding: whiskerTooltipEncoding
  })), _toConsumableArray(makeBoxPlotExtent({
    partName: 'ticks',
    mark: endTick,
    positionPrefix: 'upper_whisker',
    extraEncoding: whiskerTooltipEncoding
  })));
  // ## Box Layers
  // TODO: support hiding certain mark parts
  var boxLayers = [].concat(_toConsumableArray(boxPlotType !== 'tukey' ? whiskerLayers : []), _toConsumableArray(makeBoxPlotBox({
    partName: 'box',
    mark: _objectSpread(_objectSpread({
      type: 'bar'
    }, sizeValue ? {
      size: sizeValue
    } : {}), {}, {
      orient: boxOrient,
      invalid: invalid,
      ariaRoleDescription: 'box'
    }),
    positionPrefix: 'lower_box',
    endPositionPrefix: 'upper_box',
    extraEncoding: fiveSummaryTooltipEncoding
  })), _toConsumableArray(makeBoxPlotMidTick({
    partName: 'median',
    mark: _objectSpread(_objectSpread(_objectSpread({
      type: 'tick',
      invalid: invalid
    }, isObject(config.boxplot.median) && config.boxplot.median.color ? {
      color: config.boxplot.median.color
    } : {}), sizeValue ? {
      size: sizeValue
    } : {}), {}, {
      orient: ticksOrient,
      aria: false
    }),
    positionPrefix: 'mid_box',
    extraEncoding: fiveSummaryTooltipEncoding
  })));
  if (boxPlotType === 'min-max') {
    var _outerSpec$transform;
    return _objectSpread(_objectSpread({}, outerSpec), {}, {
      transform: ((_outerSpec$transform = outerSpec.transform) !== null && _outerSpec$transform !== void 0 ? _outerSpec$transform : []).concat(transform),
      layer: boxLayers
    });
  }
  // Tukey Box Plot
  var lowerBoxExpr = accessWithDatumToUnescapedPath("lower_box_".concat(continuousAxisChannelDef.field));
  var upperBoxExpr = accessWithDatumToUnescapedPath("upper_box_".concat(continuousAxisChannelDef.field));
  var iqrExpr = "(".concat(upperBoxExpr, " - ").concat(lowerBoxExpr, ")");
  var lowerWhiskerExpr = "".concat(lowerBoxExpr, " - ").concat(extent, " * ").concat(iqrExpr);
  var upperWhiskerExpr = "".concat(upperBoxExpr, " + ").concat(extent, " * ").concat(iqrExpr);
  var fieldExpr = accessWithDatumToUnescapedPath(continuousAxisChannelDef.field);
  var joinaggregateTransform = {
    joinaggregate: boxParamsQuartiles(continuousAxisChannelDef.field),
    groupby: groupby
  };
  var filteredWhiskerSpec = {
    transform: [{
      filter: "(".concat(lowerWhiskerExpr, " <= ").concat(fieldExpr, ") && (").concat(fieldExpr, " <= ").concat(upperWhiskerExpr, ")")
    }, {
      aggregate: [{
        op: 'min',
        field: continuousAxisChannelDef.field,
        as: "lower_whisker_".concat(aliasedFieldName)
      }, {
        op: 'max',
        field: continuousAxisChannelDef.field,
        as: "upper_whisker_".concat(aliasedFieldName)
      },
      // preserve lower_box / upper_box
      {
        op: 'min',
        field: "lower_box_".concat(continuousAxisChannelDef.field),
        as: "lower_box_".concat(aliasedFieldName)
      }, {
        op: 'max',
        field: "upper_box_".concat(continuousAxisChannelDef.field),
        as: "upper_box_".concat(aliasedFieldName)
      }].concat(_toConsumableArray(aggregate)),
      groupby: groupby
    }],
    layer: whiskerLayers
  };
  var tooltip = encodingWithoutSizeColorAndContinuousAxis.tooltip,
    encodingWithoutSizeColorContinuousAxisAndTooltip = _objectWithoutProperties(encodingWithoutSizeColorAndContinuousAxis, _excluded3);
  var scale = continuousAxisChannelDef.scale,
    axis = continuousAxisChannelDef.axis;
  var title = getTitle(continuousAxisChannelDef);
  var axisWithoutTitle = omit(axis, ['title']);
  var outlierLayersMixins = partLayerMixins(markDef, 'outliers', config.boxplot, {
    transform: [{
      filter: "(".concat(fieldExpr, " < ").concat(lowerWhiskerExpr, ") || (").concat(fieldExpr, " > ").concat(upperWhiskerExpr, ")")
    }],
    mark: 'point',
    encoding: _objectSpread(_objectSpread(_objectSpread(_defineProperty({}, continuousAxis, _objectSpread(_objectSpread(_objectSpread({
      field: continuousAxisChannelDef.field,
      type: continuousAxisChannelDef.type
    }, title !== undefined ? {
      title: title
    } : {}), scale !== undefined ? {
      scale: scale
    } : {}), isEmpty(axisWithoutTitle) ? {} : {
      axis: axisWithoutTitle
    })), encodingWithoutSizeColorContinuousAxisAndTooltip), color ? {
      color: color
    } : {}), customTooltipWithoutAggregatedField ? {
      tooltip: customTooltipWithoutAggregatedField
    } : {})
  })[0];
  var filteredLayersMixins;
  var filteredLayersMixinsTransforms = [].concat(_toConsumableArray(bins), _toConsumableArray(timeUnits), [joinaggregateTransform]);
  if (outlierLayersMixins) {
    filteredLayersMixins = {
      transform: filteredLayersMixinsTransforms,
      layer: [outlierLayersMixins, filteredWhiskerSpec]
    };
  } else {
    var _filteredLayersMixins;
    filteredLayersMixins = filteredWhiskerSpec;
    (_filteredLayersMixins = filteredLayersMixins.transform).unshift.apply(_filteredLayersMixins, _toConsumableArray(filteredLayersMixinsTransforms));
  }
  return _objectSpread(_objectSpread({}, outerSpec), {}, {
    layer: [filteredLayersMixins, {
      // boxplot
      transform: transform,
      layer: boxLayers
    }]
  });
}
function boxParamsQuartiles(continousAxisField) {
  var aliasedFieldName = removePathFromField(continousAxisField);
  return [{
    op: 'q1',
    field: continousAxisField,
    as: "lower_box_".concat(aliasedFieldName)
  }, {
    op: 'q3',
    field: continousAxisField,
    as: "upper_box_".concat(aliasedFieldName)
  }];
}
function boxParams(spec, extent, config) {
  var orient = compositeMarkOrient(spec, BOXPLOT);
  var _compositeMarkContinu = compositeMarkContinuousAxis(spec, orient, BOXPLOT),
    continuousAxisChannelDef = _compositeMarkContinu.continuousAxisChannelDef,
    continuousAxis = _compositeMarkContinu.continuousAxis;
  var continuousFieldName = continuousAxisChannelDef.field;
  var aliasedFieldName = removePathFromField(continuousFieldName);
  var boxPlotType = getBoxPlotType(extent);
  var boxplotSpecificAggregate = [].concat(_toConsumableArray(boxParamsQuartiles(continuousFieldName)), [{
    op: 'median',
    field: continuousFieldName,
    as: "mid_box_".concat(aliasedFieldName)
  }, {
    op: 'min',
    field: continuousFieldName,
    as: (boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_') + aliasedFieldName
  }, {
    op: 'max',
    field: continuousFieldName,
    as: (boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_') + aliasedFieldName
  }]);
  var postAggregateCalculates = boxPlotType === 'min-max' || boxPlotType === 'tukey' ? [] : [
  // This is for the  original k-IQR, which we do not expose
  {
    calculate: "".concat(accessWithDatumToUnescapedPath("upper_box_".concat(aliasedFieldName)), " - ").concat(accessWithDatumToUnescapedPath("lower_box_".concat(aliasedFieldName))),
    as: "iqr_".concat(aliasedFieldName)
  }, {
    calculate: "min(".concat(accessWithDatumToUnescapedPath("upper_box_".concat(aliasedFieldName)), " + ").concat(accessWithDatumToUnescapedPath("iqr_".concat(aliasedFieldName)), " * ").concat(extent, ", ").concat(accessWithDatumToUnescapedPath("max_".concat(aliasedFieldName)), ")"),
    as: "upper_whisker_".concat(aliasedFieldName)
  }, {
    calculate: "max(".concat(accessWithDatumToUnescapedPath("lower_box_".concat(aliasedFieldName)), " - ").concat(accessWithDatumToUnescapedPath("iqr_".concat(aliasedFieldName)), " * ").concat(extent, ", ").concat(accessWithDatumToUnescapedPath("min_".concat(aliasedFieldName)), ")"),
    as: "lower_whisker_".concat(aliasedFieldName)
  }];
  var _spec$encoding = spec.encoding,
    oldContinuousAxisChannelDef = _spec$encoding[continuousAxis],
    oldEncodingWithoutContinuousAxis = _objectWithoutProperties(_spec$encoding, [continuousAxis].map(_toPropertyKey));
  var _filterTooltipWithAgg = filterTooltipWithAggregatedField(oldEncodingWithoutContinuousAxis),
    customTooltipWithoutAggregatedField = _filterTooltipWithAgg.customTooltipWithoutAggregatedField,
    filteredEncoding = _filterTooltipWithAgg.filteredEncoding;
  var _extractTransformsFro = extractTransformsFromEncoding(filteredEncoding, config),
    bins = _extractTransformsFro.bins,
    timeUnits = _extractTransformsFro.timeUnits,
    aggregate = _extractTransformsFro.aggregate,
    groupby = _extractTransformsFro.groupby,
    encodingWithoutContinuousAxis = _extractTransformsFro.encoding;
  var ticksOrient = orient === 'vertical' ? 'horizontal' : 'vertical';
  var boxOrient = orient;
  var transform = [].concat(_toConsumableArray(bins), _toConsumableArray(timeUnits), [{
    aggregate: [].concat(_toConsumableArray(aggregate), _toConsumableArray(boxplotSpecificAggregate)),
    groupby: groupby
  }], postAggregateCalculates);
  return {
    bins: bins,
    timeUnits: timeUnits,
    transform: transform,
    groupby: groupby,
    aggregate: aggregate,
    continuousAxisChannelDef: continuousAxisChannelDef,
    continuousAxis: continuousAxis,
    encodingWithoutContinuousAxis: encodingWithoutContinuousAxis,
    ticksOrient: ticksOrient,
    boxOrient: boxOrient,
    customTooltipWithoutAggregatedField: customTooltipWithoutAggregatedField
  };
}